import { render } from "./BlankPage.vue?vue&type=template&id=5d056903&scoped=true&ts=true"
import script from "./BlankPage.vue?vue&type=script&lang=ts"
export * from "./BlankPage.vue?vue&type=script&lang=ts"

import "./BlankPage.vue?vue&type=style&index=0&id=5d056903&scoped=true&lang=css"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d056903"]])

export default __exports__